/**
 * @generated SignedSource<<307520fdf9460d16506cc1fd715da691>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate";
};
export type SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate$key = {
  readonly " $data"?: SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "SignalWorkspaceTemplate",
  "abstractKey": null
};

(node as any).hash = "4a5bf859515c50212de24c3e8b446d37";

export default node;
